import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import logo from "../assets/images/80eight/88-footer-white.svg";
import Toaster from "./ui/toaster";
import bgVideo from "../assets/images/loader.mp4";

export default function SpinningLoader() {
  return (
    <AnimatePresence>
      <motion.div
        key="loader"
        className="min-h-screen w-full flex items-center justify-center dark:bg-black bg-white fixed inset-0 z-50"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.4 }}
      >
        <div className="relative flex items-center justify-center w-full h-full px-6">
          <div className="relative w-full max-w-[720px] aspect-[45/32]">
            <video
              src={bgVideo}
              autoPlay
              loop
              muted
              playsInline
              className="h-full w-full object-contain"
            />
            <img
              src={logo}
              alt="Logo"
              className="absolute inset-0 z-[1000] m-auto w-[160px] h-auto"
            />
          </div>
        </div>
      </motion.div>
      <Toaster key="toaster" />
    </AnimatePresence>
  );
}
